import React from 'react';
import classNames from 'classnames';
import styles from './Select.module.css';
import {
  components,
  ControlProps,
  MultiValueProps,
  InputProps,
  PlaceholderProps,
  SingleValueProps,
  OptionProps,
  MenuProps,
} from 'react-select';

export const Control: React.FC<ControlProps> = ({ children, ...props }) => {
  return (
    <components.Control
      {...props}
      className={classNames(
        styles['reactSelectControl'],
        {
          [styles['reactSelectControlFocused']]: props.isFocused,
        },
        props.className
      )}
    >
      {children}
    </components.Control>
  );
};

export const MultiValue: React.FC<MultiValueProps> = ({
  children,
  ...props
}) => {
  return (
    <components.MultiValue
      {...props}
      className={classNames(styles['multiValue'])}
    >
      {children}
    </components.MultiValue>
  );
};

export const Input: React.FC<InputProps> = ({ ...props }) => {
  return (
    <components.Input
      {...props}
      inputClassName={classNames(styles['inputEl'])}
    />
  );
};

export const Placeholder: React.FC<PlaceholderProps> = ({
  children,
  ...props
}) => {
  return (
    <components.Placeholder
      {...props}
      className={classNames(styles['placeholder'])}
    >
      {children}
    </components.Placeholder>
  );
};

export const SingleValue: React.FC<SingleValueProps> = ({
  children,
  ...props
}) => {
  return (
    <components.SingleValue
      {...props}
      className={classNames(styles['singleValue'])}
    >
      {children}
    </components.SingleValue>
  );
};
export const Menu: React.FC<MenuProps> = ({ children, ...props }) => {
  return (
    <components.Menu {...props} className={classNames(styles['menu'])}>
      {children}
    </components.Menu>
  );
};

export const Option: React.FC<OptionProps> = ({ children, ...props }) => {
  return (
    <components.Option
      {...props}
      className={classNames(styles['option'], {
        '!bg-primary-500': props.isSelected,
      })}
    >
      {children}
    </components.Option>
  );
};
